import React, { FC, PropsWithChildren } from 'react';

export const AdminContainer: FC<PropsWithChildren> = ({ children }) => (
  <div className="m-5 flex flex-col gap-3 bg-unaula-gray p-5 shadow-unaula-box rounded-2xl">{children}</div>
);
